import { QueryClientConfig } from "@tanstack/react-query";
import { PopconfirmProps } from "antd";
import { PaginationConfig } from "antd/es/pagination";
import { AxiosError, HttpStatusCode } from "axios";

export const DefaultListPaginationProps: PaginationConfig = {
    pageSize: 5,
    position: "bottom",
    align: "center",
}

export const PropriedadesDoPopConfirm = (tipo: "desativar" | "ativar") : PopconfirmProps => {
    switch (tipo) {
        case "ativar":
            return {
                title: 'Atenção',
                description: 'Tem certeza que deseja ativar este registro?',
                okText: 'Confirmar',
                cancelText: 'Cancelar'
            }
        case "desativar":
            return {
                title: 'Atenção',
                description: 'Tem certeza que deseja desativar este registro?',
                okText: 'Confirmar',
                cancelText: 'Cancelar'
            }
    }
}

export const DefaultQueryClientConfig: QueryClientConfig = {
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry(failureCount, error) {
                try {
                    const status = (error as AxiosError).response?.status;
                    if (
                        status === HttpStatusCode.Forbidden || 
                        status === HttpStatusCode.NotFound ||
                        status === HttpStatusCode.UnprocessableEntity 
                    ) return false
                } catch {
                }

                if (failureCount < 2) return true; // Caso haja erro, no máximo 2 tentativas serão efetuadas (failureCount parte de 0)

                return false;
            }
        }
    }
}